import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "height"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import IconBase from '../icons/IconBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Close = function Close(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 25 : _ref$height,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(IconBase, _objectSpread(_objectSpread({
    $styles: {
      width: width,
      height: height
    },
    viewBox: props.bold ? '0 0 24 24' : '0 0 24 25'
  }, props), {}, {
    children: props.bold ? /*#__PURE__*/_jsx("path", {
      d: "M8.7071 7.29289C8.31658 6.90237 7.68341 6.90237 7.29289 7.2929C6.90237 7.68342 6.90237 8.31659 7.2929 8.70711L10.5871 12.0013L7.2929 15.2954C6.90237 15.6859 6.90237 16.3191 7.29289 16.7096C7.68341 17.1001 8.31658 17.1002 8.7071 16.7096L12.0013 13.4155L15.2955 16.7096C15.686 17.1001 16.3191 17.1001 16.7097 16.7096C17.1002 16.3191 17.1002 15.6859 16.7097 15.2954L13.4155 12.0013L16.7097 8.70715C17.1002 8.31663 17.1002 7.68346 16.7097 7.29293C16.3191 6.90241 15.686 6.90241 15.2955 7.29293L12.0013 10.5871L8.7071 7.29289Z",
      fill: "currentColor"
    }) : /*#__PURE__*/_jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        transform: "translate(-1257.000000, -323.000000)",
        fillRule: "nonzero",
        children: /*#__PURE__*/_jsxs("g", {
          transform: "translate(1251.000000, 318.000000)",
          children: [/*#__PURE__*/_jsx("g", {
            transform: "translate(6.000000, 4.456731)",
            fill: "currentColor",
            children: /*#__PURE__*/_jsx("path", {
              d: "M9.8786796,13.4567308 L0.439339826,22.8733798 C-0.146446609,23.4577582 -0.146446609,24.4052226 0.439339826,24.9896009 C1.02512626,25.5739792 1.97487373,25.5739792 2.56066017,24.9896009 L12,15.5729518 L21.4393398,24.9896009 C22.0251262,25.5739792 22.9748737,25.5739792 23.5606602,24.9896009 C24.1464466,24.4052226 24.1464466,23.4577582 23.5606602,22.8733798 L14.1213204,13.4567308 L23.5606602,4.04008166 C24.1464466,3.45570336 24.1464466,2.50823894 23.5606602,1.92386064 C22.9748737,1.33948235 22.0251262,1.33948235 21.4393398,1.92386064 L12,11.3405097 L2.56066017,1.92386064 C1.97487373,1.33948235 1.02512626,1.33948235 0.439339826,1.92386064 C-0.146446609,2.50823894 -0.146446609,3.45570336 0.439339826,4.04008166 L9.8786796,13.4567308 Z"
            })
          }), /*#__PURE__*/_jsx("rect", {
            x: "0",
            y: "0",
            width: "36",
            height: "36"
          })]
        })
      })
    })
  }));
};

export default Close;